const organizations = {
    title: 'องค์กร',
    description: 'สร้างและจัดการองค์กรที่คุณเป็นสมาชิก',
    create: 'สร้างองค์กร',
    create_title: 'สร้างองค์กรใหม่',
    name: 'ชื่อองค์กร',
    avatar: 'รูปประจำองค์กร',
    avatar_removed: 'นำรูปประจำองค์กรออกแล้ว',
    description_label: 'คำอธิบาย',
    empty: 'คุณยังไม่ได้เป็นสมาชิกขององค์กรใด',
    pending_invitations: 'คำเชิญที่รอดำเนินการ',
    accept: 'ยอมรับ',
    decline: 'ปฏิเสธ',
    owner: 'เจ้าของ',
    tabs: {
        overview: 'ภาพรวม',
        members: 'สมาชิก',
        invitations: 'คำเชิญ',
        roles: 'บทบาทการจัดการ',
        branding: 'แบรนด์',
        security: 'ความปลอดภัย',
        jit: 'การจัดเตรียม JIT',
        applications: 'ทรัพยากรที่แชร์',
        activity: 'กิจกรรม',
        deletion: 'ลบ',
    },
    members: {
        title: 'สมาชิก',
        empty: 'ไม่พบสมาชิก',
        remove: 'นำออก',
        removed: 'นำสมาชิกออกแล้ว',
        business_roles: 'บทบาททางธุรกิจ',
        no_business_roles: 'ไม่มีบทบาททางธุรกิจที่พร้อมใช้งาน โปรดขอให้ผู้ดูแลเทนแนนต์แชร์บทบาทกับองค์กรนี้',
    },
    invitations: {
        title: 'คำเชิญ',
        invite: 'เชิญสมาชิก',
        email: 'ที่อยู่อีเมล',
        empty: 'ไม่พบคำเชิญ',
        resend: 'ส่งอีกครั้ง',
        resent: 'ส่งคำเชิญอีกครั้งแล้ว',
        revoke: 'เพิกถอน',
        revoked: 'เพิกถอนคำเชิญแล้ว',
        status: {
            Pending: 'รอดำเนินการ',
            Accepted: 'ยอมรับแล้ว',
            Expired: 'หมดอายุ',
            Revoked: 'เพิกถอนแล้ว',
            Declined: 'ปฏิเสธแล้ว',
        },
    },
    roles: {
        title: 'บทบาทการจัดการ',
        create: 'สร้างบทบาท',
        permissions: 'สิทธิ์',
        empty: 'ไม่พบบทบาทการจัดการ',
        select_member: 'เลือกสมาชิก',
        select_role: 'เลือกบทบาท',
        assign: 'มอบหมายบทบาท',
        assigned: 'มอบหมายบทบาทแล้ว',
        unassign: 'นำบทบาทออก',
        unassigned: 'นำบทบาทออกแล้ว',
        permission_count: 'จำนวนสิทธิ์: {{count}}',
        built_in: {
            owner: 'เจ้าของ',
            owner_description: 'เจ้าของมีสิทธิ์เฉพาะในการจัดการความเป็นเจ้าของและลบองค์กร',
            administrator: 'ผู้ดูแลระบบ',
            administrator_description: 'จัดการองค์กรได้ ยกเว้นการดำเนินการที่สงวนไว้สำหรับเจ้าของ',
        },
        permission_labels: {
            update_profile: 'อัปเดตโปรไฟล์',
            manage_branding: 'จัดการแบรนด์',
            view_members: 'ดูสมาชิก',
            manage_members: 'จัดการสมาชิก',
            manage_invitations: 'จัดการคำเชิญ',
            assign_business_roles: 'มอบหมายบทบาททางธุรกิจ',
            manage_management_roles: 'จัดการบทบาทการจัดการ',
            assign_management_roles: 'มอบหมายบทบาทการจัดการ',
            manage_security: 'จัดการความปลอดภัย',
            manage_jit: 'จัดการการจัดเตรียม JIT',
            manage_applications: 'จัดการแอปพลิเคชัน',
            view_activity: 'ดูกิจกรรม',
        },
    },
    branding: {
        title: 'แบรนด์องค์กร',
        primary_color: 'สีหลัก',
        custom_css: 'CSS ที่กำหนดเอง',
        preview: 'ดูตัวอย่าง',
        light: 'สว่าง',
        dark: 'มืด',
    },
    security: {
        title: 'ความปลอดภัยขององค์กร',
        require_mfa: 'กำหนดให้สมาชิกใช้การยืนยันตัวตนแบบหลายปัจจัย',
    },
    jit: {
        title: 'โดเมนอีเมล JIT',
        domain: 'โดเมนอีเมล',
        add: 'เพิ่มโดเมน',
        verify: 'ตรวจสอบ DNS',
        dns_instruction: 'สร้างระเบียน TXT {{record}} ด้วยค่า {{value}}',
        verified: 'ยืนยันแล้ว',
    },
    applications: {
        title: 'ทรัพยากรที่แชร์',
        empty: 'ไม่มีทรัพยากรที่พร้อมใช้งานสำหรับองค์กรนี้',
        sso: 'การเชื่อมต่อ SSO ขององค์กร',
        m2m: 'แอปพลิเคชันระหว่างเครื่อง',
    },
    activity: {
        title: 'กิจกรรมขององค์กร',
        empty: 'ยังไม่มีกิจกรรม',
        events: {
            create: 'สร้างองค์กรแล้ว',
            delete: 'ลบองค์กรแล้ว',
            profile: 'อัปเดตโปรไฟล์องค์กรแล้ว',
            branding: 'อัปเดตแบรนด์องค์กรแล้ว',
            security: 'อัปเดตความปลอดภัยองค์กรแล้ว',
            member_add: 'เพิ่มสมาชิกแล้ว',
            member_remove: 'นำสมาชิกออกแล้ว',
            owner: 'อัปเดตความเป็นเจ้าขององค์กรแล้ว',
            role_create: 'สร้างบทบาทการจัดการแล้ว',
            role_update: 'อัปเดตบทบาทการจัดการแล้ว',
            role_delete: 'ลบบทบาทการจัดการแล้ว',
            role_assign: 'มอบหมายบทบาทการจัดการแล้ว',
            role_unassign: 'นำบทบาทการจัดการออกจากสมาชิกแล้ว',
            business_role: 'อัปเดตบทบาททางธุรกิจแล้ว',
            invitation_create: 'ส่งคำเชิญแล้ว',
            invitation_accept: 'ยอมรับคำเชิญแล้ว',
            invitation_decline: 'ปฏิเสธคำเชิญแล้ว',
            invitation_revoke: 'เพิกถอนคำเชิญแล้ว',
            jit: 'อัปเดตการจัดเตรียม JIT แล้ว',
            domain: 'การยืนยันโดเมนอีเมล',
            application: 'อัปเดตการเชื่อมต่อแอปพลิเคชันแล้ว',
            unknown: 'กิจกรรมขององค์กร',
        },
    },
    save: 'บันทึกการเปลี่ยนแปลง',
    cancel: 'ยกเลิก',
    delete: 'ลบองค์กร',
    delete_confirmation: 'การดำเนินการนี้จะลบองค์กรและความเป็นสมาชิกอย่างถาวร ป้อน “{{name}}” เพื่อยืนยัน',
    deleted: 'ลบองค์กรแล้ว',
    load_failed: 'ไม่สามารถโหลดข้อมูลองค์กรได้ โปรดลองอีกครั้ง',
    permission_denied: 'คุณไม่มีสิทธิ์ดูส่วนนี้',
};
export default organizations;
